import BaseModel from './BaseModel';

export default class QrMenuCategory extends BaseModel {
   getId() {
      return this.get('id');
   }
}
